import React from "react";
import css from './AboutSection.scss';
import prefCss from '../PreferencesSection.scss';
import PreferencesSection from "../PreferencesSection";
import classnames from "classnames";
import { getWord } from 'utils/tenant';
import { isValidStaffTitle } from '../profileValidation';
import { TextArea } from "semantic-ui-react";
import PropTypes from "prop-types";
import Icon from 'SF/MaterialIcon';

const AboutSection = ({generalOverview, biography, setValue, title, isIE}) => {
    return (
        <PreferencesSection isStaff
                            className={classnames(css['about-profile'], { [css.ie]: isIE })}
                            headerText="About"
                            descriptionText="Customize your Biography and General Overview">
            <div className={classnames(css['title-section'],  {[prefCss.error]: !isValidStaffTitle(title)})}>
                    <label id="staff-title">Title</label>
                    <input type="text"
                           aria-labelledby="staff-title"
                           onChange={(e) => setValue({ title: e.target.value }) }
                           value={title} />
                    { !isValidStaffTitle(title) && <span className={prefCss['error-message']} aria-hidden={!isValidStaffTitle(title)}>
                            <Icon icon="error" aria-hidden="true" />Title is {title.length - 140} over 140 character limit.
                        </span> }
                    <span className={prefCss['consistent-info-message']}>
                        Will display to students to help them identify your services.
                    </span>
            </div>
            <div>
                <label id="biography" className={css['labelText']}>My Biography</label>
                <span className={css['informational-text']}>
                    Tell students about your educational background, areas of research, or other information about your expertise.
                </span>
                <TextArea className={css['text-area']}
                          rows={5}
                          autoHeight
                          aria-labelledby="biography"
                          value={biography}
                          onChange={(e) => setValue({biography: e.target.value})} />
                <label id="overview" className={css['labelText']}>General Overview</label>
                <span className={css['informational-text']}>
                    Tell students what help you offer during {getWord('officeHours', true)} and/or directions to your office.
                </span>
                <TextArea className={css['text-area']}
                          rows={5}
                          autoHeight
                          value={generalOverview}
                          aria-labelledby="overview"
                          onChange={(e) => setValue({generalOverview: e.target.value})} />
            </div>
        </PreferencesSection>
    )
};

AboutSection.propTypes = {
    setValue: PropTypes.func.isRequired,
    title: PropTypes.string,
    generalOverview: PropTypes.string,
    biography: PropTypes.string,
    isIE: PropTypes.bool
}

export default AboutSection;
